"use strict";exports.getLinkRel=(t,e,s,i,r)=>"a"===i&&e&&s&&"page"===r?1===t?"first":t===s?"last":t===e-1?"prev":t===e+1?"next":void 0:"a"!==i||"next"!==r&&"last"!==r&&"first"!==r&&"previous"!==r?void 0:r;
